import { Col, Row } from "antd"
import CheckBoxHorizontal from "../../CheckBoxHorizontal"
import { ConsentStatus, DayOfWeekType, DeviceType } from "../../../../__generated__/graphql"
import CheckboxListField from "../../CheckboxListField"
import HourPickerField from "../../HourPickerField"
import SearchMultiSelect from "../../SearchSelect"
import SectionsField from "./SectionsField"

const TargetingFields = () => {
  return (
    <Row>
      <Col span={24}>
        <CheckBoxHorizontal
          top={true}
          required={false}
          label={'Device Type Targeting'}
          values={[
            {name: 'Desktop', _id: DeviceType.Desktop},
            {name: 'Mobile', _id: DeviceType.Mobile},
            {name: 'Tablet', _id: DeviceType.Tablet},
          ]}
          htmlFor='targeting.deviceType'
        />
      </Col>
      <Col span={24}>
        <CheckBoxHorizontal
          top={true}
          required={false}
          label={'User Consent Type'}
          values={[
            {name: 'Not Consented', _id: ConsentStatus.UnConsented},
            {name: 'Consented', _id: ConsentStatus.Consented},
          ]}
          htmlFor='targeting.consentStatus'
        />
      </Col>
      <Col span={24}>
        <CheckboxListField
          top={true}
          required={false}
          label={'Time Based Targeting'}
          values={[
            {name: 'Monday', _id: DayOfWeekType.Monday},
            {name: 'Tuesday', _id: DayOfWeekType.Tuesday},
            {name: 'Wednesday', _id: DayOfWeekType.Wednesday},
            {name: 'Thursday', _id: DayOfWeekType.Thursday},
            {name: 'Friday', _id: DayOfWeekType.Friday},
            {name: 'Saturday', _id: DayOfWeekType.Saturday},
            {name: 'Sunday', _id: DayOfWeekType.Sunday},
          ]}
          htmlfor='targeting.dayOfWeek'
        />
      </Col>
      <Col span={24}>
        <HourPickerField label='Hours' name='targeting.timeRange' top={true} />
      </Col>
      <Col span={24} className='mt-4'>
        <SearchMultiSelect name='targeting.location' />
      </Col>
      <Col span={24} className='mt-4'>
        <SectionsField />
      </Col>
    </Row>
  )
}

export default TargetingFields
